import { render, staticRenderFns } from "./block_edit.vue?vue&type=template&id=24d3aad4&"
import script from "./block_edit.vue?vue&type=script&lang=ts&"
export * from "./block_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports